module.exports = __webpack_public_path__ + "static/img/ent-29.0a9e589.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-29.jpg
// module id = n6js
// module chunks = 52